import React, { useRef } from 'react'
import { useParams } from '@tanstack/react-router'
import MainLayout from '../../components/layouts/main-layout'
import Header from '../../components/layouts/header/header'
import DictionarySearchBar from '../../components/search/dictionary-search-bar'
import useTranslationForm from '../../hooks/useTranslationForm'
import { getBlogPost } from '../../components/blog/posts'
// Renders in the server HTML, so it's a static import — see main-layout.tsx
// for why lazy() costs a flash of unstyled content here.
import BlogPost from '../../components/blog/blog-post'

// The /blog section is home to the newer, richly-laid-out posts, all sharing
// the one BlogPost layout and each written as markdown in src/content/blog.
// The older plain-HTML articles still live under /learn (see
// pages/learn/[blog-slug].tsx).
const Blog = () => {
   const { blogSlug } = useParams({ from: '/blog/$blogSlug' })
   const post = getBlogPost(blogSlug)
   const textareaRef = useRef<HTMLTextAreaElement | null>(null)
   const { onSubmit, resetForm, control, register } = useTranslationForm(textareaRef)

   return (
      <MainLayout>
         <Header
            compact
            onClick={resetForm}
            onModalClose={() => {
               onSubmit()
            }}
         >
            <DictionarySearchBar
               register={register}
               control={control}
               onSubmit={onSubmit}
               onClear={resetForm}
               textareaRef={textareaRef}
            />
         </Header>
         {post ? (
            <BlogPost post={post} />
         ) : (
            <main className="container blog-wrapper text-center my-20">
               <div>Article not found</div>
            </main>
         )}
      </MainLayout>
   )
}

export default Blog
